import { get, token, DEV_TOKEN } from './api.js';

export function load(id) {
    return get(`version/`, token || DEV_TOKEN);
}
